import evite from 'evite';
import _ from './lodash.underscore-v3.10.min';

evite.resolve('lodash', _);



//////////////////
// WEBPACK FOOTER
// ./assets/js-lib/lodash.js
// module id = 775
// module chunks = 46